/** Docker publish forms: `3000:3000`, `127.0.0.1:3001:3001` → host/listen port */
export function hostPortFromPortBinding(binding) {
  if (binding == null || typeof binding !== 'string') return undefined;
  const n = binding
    .split(':')
    .filter((s) => /^\d+$/.test(s))
    .map(Number);
  if (n.length >= 2) return n[n.length - 2];
  return n[0];
}
